import Auth from "../libs/API/Auth";
import Users from "../libs/API/Users";
import moment from "moment";
import Alert from "./Alert";
import GlobalNotificationHeader from "./GlobalNotificationHeader";
class NotificationDocumentExpirationDateSalesPartnerClass{
    constructor(){
        this._data = null;
        this.today = moment().startOf('day');
    }

    init(){
        Auth.addEventListener('sessionReady', async ()=>{
            if (Auth.isExternalSellerLogged) {
                this._data = await Users.getProfile();
                if(this._data){
                    this._checkNotification();
                }
            }
        })
    }

    _checkNotification(){
        if(this._data.document_expiration_date){
            let expirationDate = moment(this._data.document_expiration_date.date).startOf('day');
            let remainingDays = expirationDate.diff(this.today, 'days');

            if(remainingDays <= 30 && remainingDays >= 0){
                GlobalNotificationHeader.addNotification({content:'Your ID document is about to expire.', type:'warning'});
            } else if (expirationDate.isBefore(this.today)) {
                GlobalNotificationHeader.addNotification({content:'Your ID document expired!.', type:'warning'});
            }
        }
    }
}

const NotificationDocumentExpirationDateSalesPartner = new NotificationDocumentExpirationDateSalesPartnerClass();
Object.seal(NotificationDocumentExpirationDateSalesPartner);

export default NotificationDocumentExpirationDateSalesPartner;